import { FC, useEffect, useRef, useState } from "react"
import { ControlProps } from "@jsonforms/core"
import { useJsonForms, withJsonFormsControlProps } from "@jsonforms/react"
import { Form, FormContentRef, useFormContext } from "@/components/Form"
import { useLocation, useParams } from "react-router-dom"
import { FormRenderMode, FormType, NestedFormRef } from "@/components/Form/types"
import { useAppDispatch } from "@/core/app/hooks"
import { setIsRecordsUpdated } from "@/core/app/slices/uassist/formSlice"

const USmartRXForm: FC<ControlProps> = (props) => {
  const { path, visible, label, schema, data, handleChange, required } = props

  // Access parent form context to register nested form ref
  // Note: USmartRXForm is rendered as part of the parent form (via JsonForms),
  // so it accesses the parent's FormContext, not the nested SmartRX form's context
  const parentFormContext = useFormContext()
  const { registerNestedFormRef, unregisterNestedFormRef } = parentFormContext
  const dispatch = useAppDispatch()
  const location = useLocation()
  // Store validation result
  const [isNestedFormValid, setIsNestedFormValid] = useState<boolean>(true)
  const { core } = useJsonForms()
  const formRef = useRef<FormContentRef>(null)
  const { patientId, caseId } = useParams()
  const [selectedTemplate, setSelectedTemplate] = useState<{
    value: string
    id: string
  } | null>(null)

  useEffect(() => {
    setSelectedTemplate(core?.data.smart_rx_template_id)
  }, [data, core?.validationMode, core?.data])

  // Register/unregister nested form ref with parent form for validation
  useEffect(() => {
    if (!visible || !selectedTemplate) return

    const nestedFormRef: NestedFormRef = {
      path,
      validate: async () => {
        if (!formRef.current) return true
        formRef.current.setShowValidationErrors(true)
        const result = await formRef.current.validateErrors()
        setIsNestedFormValid(result)
        return result
      }
    }

    registerNestedFormRef(path, nestedFormRef)

    return () => {
      unregisterNestedFormRef(path)
    }
  }, [visible, selectedTemplate, path, registerNestedFormRef, unregisterNestedFormRef])

  return (
    <>
      {
        visible && selectedTemplate && !schema?.summary &&(
          <>
            <Form
              ref={formRef}
              details={{
                patientId,
                caseId,
                formType: FormType.SMARTRX,
                formName: selectedTemplate.value,
                uassistRound: 0,
                fetchSavedData: true,
                displayMeta: {
                  formTitle: null,
                  formDescription: null
                },
                isNestedForm: true,
              }}
              mode={FormRenderMode.EDIT}
              onChange={(data) => location.pathname.includes("/attentionBanner/RxForm") && dispatch(setIsRecordsUpdated(true)) }
            />
          </>
        )
      }
    </>
  )
}

export default withJsonFormsControlProps(USmartRXForm)
